// extracted by mini-css-extract-plugin
export default {"mainContainer":"AddImage_mainContainer__wr519","uploadBtn":"AddImage_uploadBtn__ob1C3","disclaimer":"AddImage_disclaimer__uaSsU","infoIcon":"AddImage_infoIcon__8Iwkt"};